import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PollResultsSchema } from './shapes';

export const getPollResults = defineEndpoint({
  method: 'GET',
  path: '/v1/polls/:pollId/results',
  params: z.object({ pollId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: PollResultsSchema }),
});
